
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

@Component({
  components: {
  },
})
export default class Banner extends Vue {

  @Prop(String)
  imgH5: string

  @Prop(String)
  imgPc: string

  @Prop(String)
  alt: string

  @Prop({ type: String, default: '' })
  title: string

  @Prop({ type: String, default: '' })
  titleWidth: string

  @Prop({ type: String, default: '' })
  mobileTitleWidth: string

  @Prop({ type: String, default: '' })
  subtitle: string

  @Prop({ type: Boolean, default: false })
  mobileCopy: boolean

  get isH5() {
    return AppModule.isH5
  }
}
